function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var MonopolyOverlayTemplate = require('./monopoly.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var MonopolyOverlay = /*#__PURE__*/function () {
  function MonopolyOverlay(app, mod) {
    _classCallCheck(this, MonopolyOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.player = null;
    this.cardname = null;
  }
  return _createClass(MonopolyOverlay, [{
    key: "render",
    value: function render(card) {
      var _this = this;
      this.overlay.show(MonopolyOverlayTemplate(this.app, this.mod, this), function () {
        //Allow to cancel by clicking out of overlay
        _this.mod.game.state.players[_this.mod.game.player - 1].devcards.push(card);
        this_dev_card.mod.game.state.canPlayCard = true;
      });
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this_self = this;
      document.querySelectorAll('.settlers-selection-overlay .settlers-desired-resources img').forEach(function (card) {
        card.onclick = function (e) {
          var target = e.currentTarget;
          var card = target.getAttribute('id');
          this_self.mod.addMove("monopoly\t".concat(this_self.player, "\t").concat(this_self.cardname, "\t").concat(card));
          this_self.mod.endTurn();
          this_self.overlay.remove();
          return 0;
        };
      });
    }
  }]);
}();
module.exports = MonopolyOverlay;